Pixlee.module("WidgetsApp.Item", function(Item, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    Item.VideoView = App.Views.ItemView.extend({
        id: 'video-box-container',
        template: require('../common/templates/_video.jst.ejs'),
        onBeforeRender: function() {
            $(this.el).appendTo(this.options.container);
        }
    });

    Item.RichAction = App.Views.ItemView.extend({
        template: require('../common/templates/_rich_action.jst.ejs'),
        className: 'rich-action-links',
        tagName: 'li',
        initialize: function() {
            this.model.on('rich:action:fetched', this.render, this);
        },
        onBeforeRender: function() {
            $(this.el).appendTo(this.options.div);
        },
        templateHelpers: function() {
            var _this = this;
            return _.extend({
                getProductTitle: function() {
                    if (_this.model.attributes.richAction) {
                        return App.request("decode:utf8", _this.model.attributes.richAction.title);
                    }

                },
                getDesc: function() {
                    if (_this.model.attributes.richAction) {
                        return _this.model.attributes.richAction.description;
                    }
                },
                getImage: function() {
                    if (_this.model.attributes.richAction) {
                        return App.request("decode:utf8", _this.model.attributes.richAction.image);
                    }
                },
                getLink: function() {
                    if (_this.model.attributes.richAction) {
                        return App.request("decode:utf8", _this.model.attributes.richAction.link);
                    }
                }
            }, App.request("concern", "PhotoHelpers"));
        },
        getActionLink: function() {
            if (!_.isFalsy(this.model.get('action_link'))) {
                return this.model.get('action_link');
            }
            if (!_.isFalsy(gon.display_options.customCallToActionLink)) {
                return gon.display_options.customCallToActionLink;
            }
            return "";
        },
        onRender: function() {
            var _this = this;
            if (!_this.model.attributes.richAction) {
                var link = this.getActionLink();
                if (link !== "") {
                    if (_this.model.attributes.action_link_title && _this.model.attributes.action_link_photo) {
                        _this.model.attributes.richAction = {
                            title: App.request("decode:utf8", _this.model.attributes.action_link_title),
                            description: "",
                            image: App.request("decode:utf8", _this.model.attributes.action_link_photo),
                            link: link
                        };
                        _this.model.trigger('rich:action:fetched');
                        return;
                    }
                }

            }
        }
    });

    Item.LightBoxDesc = App.Views.ItemView.extend({
        id: 'fancybox-description-container',
        template: require('../common/templates/_desc.jst.ejs'),
        onBeforeRender: function() {
            this.currentUserModel = App.currentUser;
            this.ecomm = false;
            if (this.currentUserModel.canAccess('ecomm') || this.currentUserModel.canAccess('ecomm_integration')) {
                gon.display_options.rich_action_active = true;
                this.ecomm = true;
            } else if (this.model.attributes.action_link_title && this.model.attributes.action_link_photo) {
                gon.display_options.rich_action_active = true;
            } else if (gon.editCssEvents) {
                gon.display_options.rich_action_active = true;
            } else if (gon.display_options.customCallToActionPhoto) {
                gon.display_options.rich_action_active = true;
            } else {
                gon.display_options.rich_action_active = false;
            }
            $(this.el).appendTo(this.options.wrapperDiv);
            this.checkAttrs();
        },
        onRender: function() {
            var _this = this;
            this.$el.find('#avatar_url_img').imagesLoaded().done(function() {
                _this.$el.find('#avatar_url_img').show();
            }).fail(function() {
                _this.$el.find('#avatar_url_placeholder').show();
            });
            if ($("#fancybox-description-container").css("background-color") != "rgb(255, 255, 255)") {
                $("#top_block").css({
                    "background-color": "transparent",
                    "border-bottom": "1px solid transparent"
                });
            }
            if (!gon.isMobileDevice) {
                if (this.ecomm) {
                    var width = 320;
                    $.get(gon.global.distilleryUrl + 'getRichActionLinks?api_key=' + gon.current_user.single_access_token + '&album_photo_id=' + _this.model.attributes.album_photo_id, function(links) {
                        if (links.length > 0) {
                            App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'), links.length);
                            $('#rich_cta_header').show();
                            _.each(links, function(link) {
                                var model = new Backbone.Model();
                                model.attributes.richAction = {
                                    link: link.link,
                                    title: link.title,
                                    image: link.image,
                                    action_link_text: link.link_text
                                };
                                _this.richAction = new Item.RichAction({
                                    model: model,
                                    div: $('#rich_action_wrapper_div')
                                });
                                _this.richAction.render();
                            });
                            if (links.length > 1) {
                                $('#rich_cta_arrows').show();
                                $("#rich_action_wrapper_div").simplecarousel({
                                    next: $('#cta_arrow_right'),
                                    prev: $('#cta_arrow_left'),
                                    visible: 1,
                                    slidespeed: 700,
                                    width: width,
                                    height: 331
                                });
                                $("#rich_action_wrapper_div").width(links.length * width);
                            }

                        } else if (_this.model.attributes.action_link_title && _this.model.attributes.action_link_photo) {
                            $('#rich_cta_header').show();
                            _this.model.attributes.richAction = {};
                            _this.model.attributes.richAction = {
                                link: _this.model.attributes.action_link,
                                title: _this.model.attributes.action_link_title,
                                image: _this.model.attributes.action_link_photo
                            };
                            _this.richAction = new Item.RichAction({
                                model: _this.model,
                                div: $('#rich_action_wrapper_div')
                            });
                            _this.richAction.render();
                            App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                        } else if (gon.display_options.customCallToActionPhoto) {
                            $('#rich_cta_header').show();
                            _this.showGlobalRichCta();
                            App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                        } else if (!_.isFalsy(gon.display_options.customCallToActionLink)) {
                            gon.display_options.rich_action_active = false;
                            _this.richAction = new Item.RichAction({
                                model: _this.model,
                                div: $('#rich_action_wrapper_div')
                            });
                            _this.richAction.render();
                            App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                        }

                    });


                } else if (this.model.attributes.action_link_title && this.model.attributes.action_link_photo) {
                    $('#rich_cta_header').show();
                    this.model.attributes.richAction = {};
                    this.model.attributes.richAction = {
                        link: this.model.attributes.action_link,
                        title: this.model.attributes.action_link_title,
                        image: this.model.attributes.action_link_photo
                    };
                    _this.richAction = new Item.RichAction({
                        model: _this.model,
                        div: $('#rich_action_wrapper_div')
                    });
                    _this.richAction.render();
                    App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                } else if (gon.display_options.customCallToActionPhoto) {
                    $('#rich_cta_header').show();
                    _this.showGlobalRichCta();
                    App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                } else {
                    _this.richAction = new Item.RichAction({
                        model: _this.model,
                        div: $('#rich_action_wrapper_div')
                    });
                    _this.richAction.render();
                    if ($('#rich_action_wrapper_div').length > 0) {
                        App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                    }

                }
            } else {
                if (this.ecomm) {
                    $('#action_link_anchor').text('');
                    $.get(gon.global.distilleryUrl + 'getRichActionLinks?api_key=' + gon.current_user.single_access_token + '&album_photo_id=' + _this.model.attributes.album_photo_id, function(links) {
                        if (links.length > 0) {
                            var img = links[0].image;
                            if (!_.isFalsy(img)) {
                                $('#buynow_button_holder').find('img').attr('src', App.request("decode:utf8", img)).show();
                            }
                            var link_text = links[0].link_text
                            if (!_.isFalsy(link_text)) {
                                $('#action_link_anchor').text(App.request("decode:utf8", link_text));
                            }
                            App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                        } else {
                            $('#action_link_anchor').remove();
                        }

                    });
                } else if (this.model.attributes.action_link_title && this.model.attributes.action_link_photo) {
                    var img = this.model.attributes.action_link_photo;
                    $('#buynow_button_holder').find('img').attr('src', App.request("decode:utf8", img)).show();
                    App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                } else if (gon.display_options.customCallToActionPhoto) {
                    var img = gon.display_options.customCallToActionPhoto;
                    $('#buynow_button_holder').find('img').attr('src', App.request("decode:utf8", img)).show();
                    App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                } else if ($('#buynow_button_holder').length > 0) {
                    App.commands.execute("action:link:loaded", _this.model.get('album_photo_id'));
                }


            }


        },
        showGlobalRichCta: function() {
            var _this = this;
            var model = new Backbone.Model();
            model.attributes.richAction = {
                link: gon.display_options.customCallToActionLink,
                title: gon.display_options.customCallToActionTitle,
                image: gon.display_options.customCallToActionPhoto
            };
            _this.richAction = new Item.RichAction({
                model: model,
                div: $('#rich_action_wrapper_div')
            });
            _this.richAction.render();
        },
        checks: [
            'user_name',
            'photo_title',
            'avatar_url'
        ],
        events: {
            "click #vote_button": 'voteClicked',
            "click #facebook_share": 'shareFacebook',
            "click #pinterest_share": 'sharePinterest',
            "click #twitter_share": 'shareTwitter',
            "click #tumblr_share": 'shareTumblr',
            "click #action_link_anchor": 'actionClicked'
        },
        initialize: function() {
            this.model.on('voted', this.toggleVote, this);
        },
        sharePinterest: function() {
            this.trigger('share:pinterest', this.model);
            return false;
        },
        shareTwitter: function() {
            this.trigger('share:twitter', this.model);
            return false;
        },
        shareTumblr: function() {
            this.trigger('share:tumblr', this.model);
            return false;
        },
        shareFacebook: function() {
            this.trigger('share:facebook', this.model);
            return false;
        },
        actionClicked: function(e) {
            var action_link_url = $(e.currentTarget).attr('href');
            var action_text = $('#buynow_button_holder').text().trim();
            this.trigger('action:clicked', this.model, action_link_url, action_text);
        },
        voteClicked: function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            if (!gon.current_album.campaign) {
                return false;
            } else {
                var _this = this;
                if (!$(this.el).find('#vote_button').hasClass('voted')) {
                    this.trigger("vote:clicked", this, this.model);
                }
            }
        },
        templateHelpers: function() {
            var _this = this;
            return _.extend({
                displayOptions: App.displayOptions.toJSON(),
                currentAlbum: App.currentAlbum.toJSON(),
                recipe: App.recipe.toJSON(),
                getVoteShareText: function() {
                    if (gon.display_options.customVoteText) {
                        return gon.display_options.customVoteText;
                    }
                    if (this.currentAlbum.campaign) {
                        return "Vote"
                    }
                    return "Share"
                },
                voted: function() {
                    var preVoted = false;
                    var _this = this;
                    if ($.cookie('pixlee_likes')) {
                        var cookies = JSON.parse($.cookie('pixlee_likes'))
                        _.each(cookies, function(cookie) {
                            if (cookie == _this.album_id + '_' + _this.album_photo_id) {
                                preVoted = true;
                            }
                        });
                    } else if ($.cookie('pixlee_likes_legacy')) {
                        var cookies = JSON.parse($.cookie('pixlee_likes_legacy'))
                        _.each(cookies, function(cookie) {
                            if (cookie == _this.album_id + '_' + _this.album_photo_id) {
                                preVoted = true;
                            }
                        });
                    }
                    return (this.userVoted || preVoted);
                }
            }, App.request("concern", "PhotoHelpers"));
        },
        toggleVote: function() {
            $(this.el).find('#vote_button').addClass("voted");
            if (this.model.get("like_count")) {
                $(this.el).find('#vote_button').find('span').text(this.model.get("like_count"));
            } else {
                $(this.el).find('#vote_button').find('span').text(!_.isFalsy(gon.display_options.customVotedText) ? App.request("decode:utf8", gon.display_options.customVotedText) : "voted");
            }

        },
        checkAttrs: function() {
            var _this = this;
            // _.each(this.checks, function(check){
            // 	var val = _this.model.attributes[check];
            // 	if (val != null && val != 'null' && typeof(val) != "undefined" && val.length && val.length > 0) {
            // 		_this.model.attributes[check + '_check'] = true;
            // 	} else {
            // 		_this.model.attributes[check + '_check'] = false;
            // 	}
            // });
        }
    });
    Item.MobileLightBoxDesc = Item.LightBoxDesc.extend({
        id: 'swipebox-description-container',
        template: require('../common/templates/_mobile_desc.jst.ejs')
    });

});
